import React, { useState, useRef, useMemo, useEffect } from 'react';
import JoditEditor from 'jodit-react';
import { useParams } from 'react-router-dom';

const JodittEditor = ({ placeholder, subTitle, editorContent, onContentChange }) => {
	const {id} = useParams();
	const editor = useRef(null);
	const [content, setContent] = useState(editorContent);
	const insertDefaultTable = (subTitle) => {
		let tableHtml = '';
		
		if (subTitle === "seminarsWorkshops") {
            tableHtml = `<table style="border-collapse:collapse;width: 100%;"><tbody>
            <tr>
            <td style="width: 33.3%;">S.No</td>
            <td style="width: 33.3%;">Department</td>
            <td style="width: 33.3%;">Number of programs attended</td>
            </tr>
            <tr>
            <td style="width: 33.3%;"><br></td>
            <td style="width: 33.3%;"><br></td>
            <td style="width: 33.3%;"><br></td>
            </tr></tbody></table>`;
        } else if (subTitle === "conference") {
            tableHtml = `<p>CONFERENCE</p><table style="border-collapse:collapse;width: 100%;"><tbody>
            <tr>
            <td style="width: 25%;">S.No</td>
            <td style="width: 25%;">Title of the event</td>
            <td style="width: 25%;">Department</td>
            <td style="width: 25%;">Period</td>
            </tr>
            <tr>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>       
            </tr></tbody></table><p>SEMINARS</p><table style="border-collapse:collapse;width: 100%;"><tbody>
            <tr>
            <td style="width: 25%;">S.No</td>
            <td style="width: 25%;">Title of the event</td>
            <td style="width: 25%;">Department</td>
            <td style="width: 25%;">Period</td>
            </tr>
            <tr>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>       
            </tr></tbody></table><p>WORKSHOPS</p><table style="border-collapse:collapse;width: 100%;"><tbody>
            <tr>
            <td style="width: 25%;">S.No</td>
            <td style="width: 25%;">Title of the event</td>
            <td style="width: 25%;">Department</td>
            <td style="width: 25%;">Period</td>
            </tr>
            <tr>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>       
            </tr></tbody></table><p>FACULTY DEVELOPMENT PROGRAMS / STTP</p><table style="border-collapse:collapse;width: 100%;"><tbody>
            <tr>
            <td style="width: 25%;">S.No</td>
            <td style="width: 25%;">Title of the event</td>
            <td style="width: 25%;">Department</td>
            <td style="width: 25%;">Period</td>
            </tr>
            <tr>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>       
            </tr></tbody></table>`;
        } else if (subTitle === "facultyParticipation") {
            tableHtml = `<table style="border-collapse:collapse;width: 100%;"><tbody>
            <tr>
            <td style="width: 16.6%;">S.No</td>
            <td style="width: 16.6%;">Name & Designation</td>
            <td style="width: 16.6%;">Department</td>
            <td style="width: 16.6%;">Paper(s)</td>
            <td style="width: 16.6%;">Number registered</td>
            <td style="width: 16.6%;">Number qualified</td>
            </tr>
            <tr>
            <td style="width: 16.6%;"><br></td>
            <td style="width: 16.6%;"><br></td>
            <td style="width: 16.6%;"><br></td>
            <td style="width: 16.6%;"><br></td>
            <td style="width: 16.6%;"><br></td>
            <td style="width: 16.6%;"><br></td>
            </tr></tbody></table>`;
        } else if (subTitle === "booksPublished") {
            tableHtml = `<table style="border-collapse:collapse;width: 100%;"><tbody>
            <tr>
            <td style="width: 25%;">Faculty Name</td>
            <td style="width: 25%;">Title of the chapter</td>
            <td style="width: 25%;">Publication</td>
            <td style="width: 25%;">Publication Year</td>
            </tr>
            <tr>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>       
            </tr></tbody></table>`;
        }
    else if (subTitle === "patentsObtained") {
            tableHtml = `<table style="border-collapse:collapse;width: 100%;"><tbody>
            <tr>
            <td style="width: 14.2%;">S.No</td>
            <td style="width: 14.2%;">Faculty Name</td>
            <td style="width: 14.2%;">Patent name</td>
            <td style="width: 14.2%;">Patent issued by</td>
            <td style="width: 14.2%;">Date of Grant</td>
            <td style="width: 14.2%;">Date of Filing</td>
            <td style="width: 14.2%;">Application number</td>
            </tr>
            <tr>
            <td style="width: 14.2%;"><br></td>
            <td style="width: 14.2%;"><br></td>
            <td style="width: 14.2%;"><br></td>
            <td style="width: 14.2%;"><br></td>
            <td style="width: 14.2%;"><br></td>
            <td style="width: 14.2%;"><br></td>
            <td style="width: 14.2%;"><br></td>
            </tr></tbody></table>`;
        }
    else if (subTitle === "equipmentsAdded") {
            tableHtml = `<table style="border-collapse:collapse;width: 100%;"><tbody>
            <tr>
            <td style="width: 25%;">S.No</td>
            <td style="width: 25%;">Name of equipment</td>
            <td style="width: 25%;">Quantity</td>
            <td style="width: 25%;">Amount</td>
            </tr>
            <tr>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>
            <td style="width: 25%;"><br></td>       
            </tr></tbody></table>`;
        }
    else if (subTitle === "financialAssistance") {
            tableHtml = `<table style="border-collapse:collapse;width: 100%;"><tbody>
            <tr>
            <td style="width: 20%;">S.No</td>
            <td style="width: 20%;">Funding agency</td>
            <td style="width: 20%;">Title of the project</td>
            <td style="width: 20%;">Name of the principal investigator & Department</td>
            <td style="width: 20%;">Funds released in</td>
            </tr>
            <tr>
            <td style="width: 20%;"><br></td>
            <td style="width: 20%;"><br></td>
            <td style="width: 20%;"><br></td>
            <td style="width: 20%;"><br></td>   
            <td style="width: 20%;"><br></td>       
            </tr></tbody></table>`;
        }
    else if (subTitle === "researchAndDevelopment") {
            tableHtml = `<table style="border-collapse:collapse;width: 100%;"><tbody>
            <tr>
            <td style="width: 20%;">S.No</td>
            <td style="width: 20%;">Funding agency</td>
            <td style="width: 20%;">Title of the project</td>
            <td style="width: 20%;">Name of the principal investigator & Department</td>
            <td style="width: 20%;">Total amount requested for the project</td>
            </tr>
            <tr>
            <td style="width: 20%;"><br></td>
            <td style="width: 20%;"><br></td>
            <td style="width: 20%;"><br></td>
            <td style="width: 20%;"><br></td>   
            <td style="width: 20%;"><br></td>       
            </tr></tbody></table>`;
        }
        else if (subTitle === "newLaboratoryCenter") {
            tableHtml = `<table style="border-collapse:collapse;width: 100%;"><tbody>
            <tr>
            <td style="width: 20%;">S.No</td>
            <td style="width: 20%;">Name of the Lab / Center</td>
            <td style="width: 20%;">Total Value</td>
            <td style="width: 20%;">Date of Establishment</td>
            <td style="width: 20%;">Sponsored By</td>
            </tr>
            <tr>
            <td style="width: 20%;"><br></td>
            <td style="width: 20%;"><br></td>
            <td style="width: 20%;"><br></td>
            <td style="width: 20%;"><br></td>   
            <td style="width: 20%;"><br></td>       
            </tr></tbody></table>`;
        }
        else if (subTitle === "listOfPapersPublished") {
            tableHtml = `<table style="border-collapse:collapse;width: 100%;"><tbody>
            <tr>
            <td style="width: 20%;">S.No</td>
            <td style="width: 20%;">Name of the Department</td>
            <td style="width: 20%;">Count in International Journal</td>
            <td style="width: 20%;">Count in National Journal</td>
            <td style="width: 20%;">Count in Conference</td>
            </tr>
            <tr>
            <td style="width: 20%;"><br></td>
            <td style="width: 20%;"><br></td>
            <td style="width: 20%;"><br></td>
            <td style="width: 20%;"><br></td>   
            <td style="width: 20%;"><br></td>       
            </tr></tbody></table>`;
        }


		setContent(tableHtml);
	};

	const insertImage = (resp) => {
		const imageUrl = `${process.env.REACT_APP_BASE_URL}/api/object/${resp.id}`;
		const imgHtml = `<img src="${imageUrl}" alt="Image" style="max-width: 100%; height: auto;" />`;
		const currentContent = editor.current?.value || content;  
		const updatedContent = currentContent + imgHtml;
		setContent(updatedContent);
		onContentChange(updatedContent);
	};

	const config = useMemo(() => ({
		readonly: false,
		placeholder: placeholder || '',
		toolbar: {
			buttons: [
				'bold',
				'italic',
				'underline',
				'image',
				'|',
				'source',
			],
		},
		uploader: {
			insertImageAsBase64URI: false,
			url: `${process.env.REACT_APP_BASE_URL}/api/report/${id}/upload`,
			headers: {
				Authorization: `Bearer ${localStorage.getItem("jwt")}`
			},
			method: 'POST',
			prepareData: (formData) => {
				const files = formData.getAll('files[0]'); 
				formData.delete('files[0]'); 
			
				files.forEach((file) => {
					formData.append('file', file); 
				});
				return formData;
			}
			,
			isSuccess: (resp) => {
				return resp;
			},
			process: (resp) => {
				console.log('File uploaded successfully:', resp);
				insertImage(resp);
				return {}; 
			},
			error: (e) => {
				console.error('Upload error', e);
			}
		},
		events: {
			beforeImage: function(current) {
				return false; 
			},
			'errorMessage': function(message) {
				console.error(message);
			}
		}
	}), [placeholder, id]);

	useEffect(() => {
		if (!editorContent) {
			insertDefaultTable(subTitle);
		 } else{
			setContent(editorContent);
		 }
	}, [subTitle]);

	const handleContentChange = (newContent) => {
		console.log("content",newContent);
		setContent(newContent);
		onContentChange(newContent);
	  };

	return (
		<JoditEditor
			ref={editor}
			value={content}
			config={config}
			tabIndex={1}
			onBlur={(newContent) => handleContentChange(newContent)}
			onChange={(newContent) => {}}
		/>
	);
};

export default JodittEditor;
